import { FlowStepId } from '../woz-flow.types';
import type { FlowContext, FlowStepDefinition } from '../woz-flow.types';

/** Main step — fetches merged address + kadaster data for the confirmed address. */
export const fetchAddressStep: FlowStepDefinition = {
  id: FlowStepId.FetchAddress,
  type: 'async',
  skipIf: (ctx: FlowContext) => !!ctx.__kadasterFetched,
};

/** Shown when the address has no ID to look up. */
export const addressUnavailableStep: FlowStepDefinition = {
  id: FlowStepId.AddressUnavailable,
  type: 'message',
  text: 'Gegevens over de woning konden niet worden opgehaald (adres-ID ontbreekt). We gaan verder zonder deze informatie.',
};

/** Shown when the address API call fails. */
export const addressFetchErrorStep: FlowStepDefinition = {
  id: FlowStepId.AddressFetchError,
  type: 'message',
  text: 'Gegevens over de woning konden niet worden opgehaald. We gaan verder zonder deze informatie.',
};

/** Summary step showing retrieved address object details. */
export const addressInfoStep = (summaryText: string): FlowStepDefinition => ({
  id: FlowStepId.AddressInfo,
  type: 'message',
  text: summaryText,
});
